export const speakLoud = [
    {
        name: '정현지',
        src: ['/img/organizer/jhj.jpeg'],
        desc: `여러분의 목소리에 힘이 되고 싶습니다. 언젠가 불편함을 느끼지 않아도 될 세상을 꿈꿉니다.`
    }, {
        name: '김나연',
        src: ['/img/organizer/jhj.jpeg'],
        desc: `여러분의 목소리에 힘이 되고 싶습니다. 언젠가 불편함을 느끼지 않아도 될 세상을 꿈꿉니다.`
    }, {
        name: '이혜정',
        src: ['/img/organizer/lhj.jpeg'],
        desc: `재미있고 행복한 것들을 찾아다니는 개발자입니다. 긍정적인 마인드를 갖으려고 노력합니다. 하쿠나 마타타~!`
    }, {
        name: '송신예',
        src: ['/img/organizer/ssy.jpeg'],
        desc: `스포츠와 프로그래밍을 사랑하는 개발자입니다. 365일 따뜻한 나라에서 오래오래 좋아하는 것들을 만들어나가는 것이 꿈입니다.`
    }, {
        name: '김지은',
        src: ['/img/organizer/kje.jpg'],
        desc: `기술과 인간의 교감을 진지하게 고민합니다. 지식과 경험을 나누는 현장을 사랑하여 계속 여러분과 함께하고자 합니다.`
    }, {
        name: '이수정',
        src: ['/img/organizer/lsj.jpg'],
        desc: `오래오래 시간이 갈수록 더 좋은 사람이 되고픈 욕심많은 개발자입니다. `
    }, {
        name: '장한보람',
        src: ['/img/organizer/robin.jpg'],
        desc: `감성과 기술의 접점에서 오래도록 일하고 싶습니다. 개발자로서 나의 삶을 사랑합니다.`
    }
];


export default {
    speakLoud
}
